module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_vm._v("Cover Design: "), _c('a', {
    attrs: {
      "href": "http://www.written-ink.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Written Ink Designs")])]), _vm._v(" | written-ink.com")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Image(s) used under a Standard Royalty-Free License.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("WARNING: This book is not transferable. It is for your own personal use. If it is sold, shared, or given away, it is an infringement of the copyright of this work and violators will be prosecuted to the fullest extent of the law.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("No portion of this book may be transmitted or reproduced in any form, or by any means, without permission in writing from the publisher, with the exception of brief excerpts used for the purposes of review.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("The author/publisher of this book makes no representation or warranties with respect to the accuracy, applicability, fitness. or completeness of the contents of this story. She disclaims any warranties (express or implied), merchantability. or fitness for any particular purpose. The author/publisher shall in no event be held liable for any loss or other damages, including but not limited to special, incidental, consequential or other damages.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Published in the United States of America.")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0548db24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003.vue
// module id = 60
// module chunks = 0